import React from "react";
import { CentralIconBase, type CentralIconBaseProps } from "../CentralIconBase";

export const IconCreditCard1: React.FC<CentralIconBaseProps> = (props) => {
  return <CentralIconBase {...props} ariaLabel="credit-card-1, card, payment"><path d="M2 5.75293C2 4.78643 2.7835 4.00293 3.75 4.00293H20.2451C21.2094 4.00293 21.9928 4.78332 21.9944 5.74876C21.9963 6.85051 21.9962 7.95233 21.9961 9.05337L21.9961 18.2461C21.9961 19.2126 21.2126 19.9961 20.2461 19.9961L3.75 19.9961C2.7835 19.9961 2 19.2126 2 18.2461V10.5H21.9961V9H2V5.75293Z" fill="currentColor"/></CentralIconBase>;
};

export default IconCreditCard1;
